import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import { setOnChange, getSyncPayload } from "../lib/store";

const AuthContext = createContext(null);
const API = process.env.REACT_APP_BACKEND_URL;

async function pushProgress() {
  try {
    await fetch(`${API}/api/progress`, {
      method: "PUT",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(getSyncPayload()),
    });
  } catch (e) {
    console.warn("Synchronisation de la progression échouée (réessai au prochain changement):", e);
  }
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const debounceRef = useRef(null);

  const enableSync = useCallback(() => {
    setOnChange(() => {
      clearTimeout(debounceRef.current);
      debounceRef.current = setTimeout(pushProgress, 800);
    });
  }, []);

  const checkAuth = useCallback(async () => {
    try {
      const res = await fetch(`${API}/api/auth/me`, { credentials: "include" });
      if (!res.ok) throw new Error("unauth");
      const u = await res.json();
      setUser(u);
      enableSync();
    } catch {
      setUser(null);
      setOnChange(null);
    } finally {
      setLoading(false);
    }
  }, [enableSync]);

  useEffect(() => {
    // Si on revient du callback OAuth, laisser AuthCallback gérer l'échange d'abord.
    if (window.location.hash && window.location.hash.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const logout = async () => {
    try {
      await fetch(`${API}/api/auth/logout`, { method: "POST", credentials: "include" });
    } catch (e) { console.warn("Déconnexion : échec réseau (session locale effacée):", e); }
    setOnChange(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, setUser, enableSync }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
